import { bootstrapWidget } from "../../common";
import RelatedPropertiesWidget from "./widget";

bootstrapWidget({ widget: RelatedPropertiesWidget, widgetType: "related-properties" });
